<template>
  <v-card id="additionalObligations" height="100%" tile>
    <pending-obligation
      v-model="actionPending"
      @close="actionPending = null"
      @cancel="actionPending = null"
      @approve="actionPending = null"
    />
    <v-navigation-drawer
      right
      fixed
      clipped
      temporary
      v-model="showDetail"
      :stateless="!showDetail || actionPending"
      width="600"
    >
      <v-row column fill-height v-if="viewActionPending">
        <v-col shrink>
          <v-app-bar dark flat color="primary">
            <v-toolbar-side-icon>
              <v-btn icon @click="closeDetail()">
                <v-icon>arrow_back</v-icon>
              </v-btn>
            </v-toolbar-side-icon>
            <v-toolbar-title dark>{{
              resx.labels.additionalDocumentationDetail
            }}</v-toolbar-title>
          </v-app-bar>
        </v-col>
        <v-col shrink>
          <v-list two-line>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">event</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  viewActionPending.createdAt | date("shortDate")
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.date
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">person</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  viewActionPending.requestedBy.fullname
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.requestedBy
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="
                !viewActionPending.data.action
                  ? (actionPending = viewActionPending)
                  : null
              "
              :ripple="!viewActionPending.data.action"
            >
              <v-list-item-action v-if="!viewActionPending.data.action">
                <v-icon color="primary">thumbs_up_down</v-icon>
              </v-list-item-action>
              <v-list-item-action
                v-if="viewActionPending.data.action == 'cancel'"
              >
                <v-icon color="error">thumb_down</v-icon>
              </v-list-item-action>
              <v-list-item-action
                v-if="viewActionPending.data.action == 'approve'"
              >
                <v-icon color="success">thumb_up</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  !viewActionPending.data.action
                    ? resx.labels.approvalPending
                    : viewActionPending.data.action == "approve"
                    ? resx.labels.approveObligation
                    : resx.labels.cancelObligation
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.state
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="!viewActionPending.data.action">
                <v-icon color="primary">chevron_right</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="viewActionPending.data.action">
              <v-list-item-action>
                <v-icon color="primary">person</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  `${viewActionPending.data.actionBy.firstname} ${viewActionPending.data.actionBy.lastname}`
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.actionPerformedBy
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="viewActionPending.data.action">
              <v-list-item-action>
                <v-icon color="primary">event</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  viewActionPending.data.actionAt | date("shortDate")
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  resx.labels.actionDateAt
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-tabs
            dark
            slot="extension"
            color="primary"
            centered
            grow
            v-model="selectedTab"
          >
            <v-tab href="#obligation">
              {{ resx.labels.obligation }}
            </v-tab>
            <v-tab href="#contractor">
              {{ resx.labels.contractor }}
            </v-tab>
            <v-tab href="#vehicle" v-if="vehicle">
              {{ resx.labels.vehicle }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="selectedTab">
            <v-tab-item :id="'obligation'">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      viewActionPending.data.obligation.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      resx.labels.name
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      resx.labels[viewActionPending.data.obligation.type]
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      resx.labels.type
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      resx.labels[viewActionPending.data.obligation.dueDateType]
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      resx.labels.dueDateType
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="
                    viewActionPending.data.obligation.dueDateType == 'monthly'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>{{
                      viewActionPending.data.obligation.dayOfMonth
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      resx.labels.dayOfMonth
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-tab-item>
            <v-tab-item :id="'contractor'">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      viewActionPending.data.contractor.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      resx.labels.name
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      viewActionPending.data.contractor.type.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      resx.labels.type
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      `${viewActionPending.data.contractor.identifier.type.toUpperCase()}: ${
                        viewActionPending.data.contractor.identifier.number
                      }`
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      resx.labels.identifier
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-tab-item>
            <v-tab-item :id="'vehicle'" v-if="vehicle">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      vehicle.description
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      resx.labels.description
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      vehicle.type.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      resx.labels.type
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      vehicle.uniqueIdentifier
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      resx.labels.domain
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-navigation-drawer>
    <v-row column fill-height>
      <v-toolbar flat card>
        <v-toolbar-title>{{
          resx.labels.additionalDocumentation
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="resx.labels.search"
          single-line
          hide-details
          v-model="search"
        >
        </v-text-field>
        <v-menu bottom auto content-class="additional-obligations-filter-menu">
          <v-btn icon slot="activator">
            <v-icon>filter_list</v-icon>
          </v-btn>
          <v-list>
            <v-list-item @click="filter = 'all'">
              <v-list-item-action>
                <v-icon color="primary" v-if="filter == 'all'">check</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ resx.labels.viewAll }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="filter = 'pendings'">
              <v-list-item-action>
                <v-icon color="primary" v-if="filter == 'pendings'"
                  >check</v-icon
                >
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  resx.labels.pendings
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="filter = 'approved'">
              <v-list-item-action>
                <v-icon color="primary" v-if="filter == 'approved'"
                  >check</v-icon
                >
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  resx.labels.approvedPlural
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="filter = 'rejected'">
              <v-list-item-action>
                <v-icon color="primary" v-if="filter == 'rejected'"
                  >check</v-icon
                >
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  resx.labels.rejectedPlural
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-col fill-height class="scrollable">
        <v-card-text class="fixed-header">
          <v-data-table
            :headers="headers"
            :items="filteredItems || []"
            :search="search"
            :no-data-text="
              firstTimeLoading ? '' : resx.messages.noObligationsAvailable
            "
            :no-results-text="
              firstTimeLoading ? '' : resx.messages.noObligationsFound
            "
            height="600"
            fixed-header
            :items-per-page="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            @update:items-per-page="saveItemsPerPage"
          >
            <template slot="items" slot-scope="props">
              <td class="justify-center align-center layout px-0">
                <v-tooltip bottom>
                  <v-icon
                    slot="activator"
                    v-if="!props.item.data.action"
                    color="info"
                    >thumbs_up_down</v-icon
                  >
                  <v-icon
                    slot="activator"
                    v-if="
                      props.item.data.action &&
                        props.item.data.action == 'approve'
                    "
                    color="success"
                    >thumb_up</v-icon
                  >
                  <v-icon
                    slot="activator"
                    v-if="
                      props.item.data.action &&
                        props.item.data.action == 'cancel'
                    "
                    color="error"
                    >thumb_down</v-icon
                  >
                  {{
                    !props.item.data.action
                      ? resx.labels.approval_pending_status
                      : props.item.data.action == "approve"
                      ? resx.labels.approveObligation
                      : resx.labels.cancelObligation
                  }}
                </v-tooltip>
              </td>
              <td class="hidden-xs-only">
                {{ props.item.createdAt | date("shortDate") }}
              </td>
              <td>
                <a @click="openDetail(props.item)">{{
                  props.item.data.obligation.name
                }}</a>
              </td>
              <td class="hidden-xs-only">
                {{ resx.labels[props.item.data.obligation.type] }}
              </td>
              <td class="hidden-sm-and-down">
                {{ props.item.data.contractorCompany.contractor.name }}
              </td>
              <td class="justify-center layout px-0">
                <v-menu bottom auto>
                  <v-btn slot="activator" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-item
                      @click="actionPending = props.item"
                      :disabled="typeof props.item.data.action != 'undefined'"
                    >
                      <v-list-item-action>
                        <v-icon color="primary">thumbs_up_down</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        `${resx.labels.approve} / ${resx.labels.reject}`
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openDetail(props.item)">
                      <v-list-item-action>
                        <v-icon color="primary">visibility</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.view
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
"use strict";

import { EventBus } from "@/bus";
import notificationService from "@/services/NotificationService";

import pendingObligation from "../pending-obligation.view.vue";

export default {
  components: { pendingObligation },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      search: null,
      firstTimeLoading: true,
      filter: "all",
      headers: [
        { align: "center", sortable: false, width: 48 },
        { text: resx.labels.date, value: "createdAt", class: "hidden-xs-only" },
        { text: resx.labels.obligation, value: "data.obligation.name" },
        {
          text: resx.labels.type,
          value: "data.obligation.type",
          class: "hidden-xs-only"
        },
        {
          text: resx.labels.contractor,
          value: "data.contractor.name",
          class: "hidden-sm-and-down"
        },
        { text: resx.labels.actions, align: "center", sortable: false }
      ],
      pagination: { sortBy: "createdAt", descending: true, rowsPerPage: -1 },
      items: null,
      showDetail: false,
      actionPending: null,
      viewActionPending: null,
      selectedTab: "obligation"
    };
  },
  watch: {
    filter(value, oldValue) {
      if (value != oldValue) {
        this.pagination.page = 1;
      }
    }
  },
  asyncComputed: {
    async filteredItems() {
      if (!this.items) {
        this.items = await notificationService.getApprovalRequestsList();
      }
      let result = [];
      switch (this.filter) {
        case "all":
          result = this.items;
          break;
        case "pendings":
          result = this.items.filter(
            item => typeof item.data.action == "undefined"
          );
          break;
        case "approved":
          result = this.items.filter(
            item =>
              typeof item.data.action != "undefined" &&
              item.data.action == "approve"
          );
          break;
        case "rejected":
          result = this.items.filter(
            item =>
              typeof item.data.action != "undefined" &&
              item.data.action == "cancel"
          );
          break;
      }
      this.firstTimeLoading = false;
      return result;
    }
  },
  computed: {
    vehicle() {
      const self = this;
      const vehicle =
        self.viewActionPending &&
        self.viewActionPending.data.contractor.vehicles.find(
          v => v._id == self.viewActionPending.data.obligation.referenceId
        );
      return vehicle;
    }
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    updatePendingApproval(event) {
      const idx = this.items.findIndex(
        item => item._id == event.result.notification._id
      );
      if (idx >= 0) {
        this.$set(this.items, idx, event.result.notification);
      }
      //todo: update selectedView
      if (this.viewActionPending) {
        this.$set(this, "viewActionPending", event.result.notification);
      }
    },
    openDetail(actionPending) {
      this.viewActionPending = actionPending;
      this.selectedTab = "obligation";
      this.showDetail = true;
    },
    closeDetail() {
      this.showDetail = false;
    }
  },
  mounted() {
    EventBus.$on("pendingApprovalObligation", this.updatePendingApproval);
  },
  destroyed() {
    EventBus.$off("pendingApprovalObligation", this.updatePendingApproval);
  }
};
</script>

<style lang="scss">
.additional-obligations-filter-menu {
  max-height: initial !important;
}
</style>
